var map = {
	"./promo-muggle-murders-rise_00.jpg": 68,
	"./promo-muggle-murders-rise_01.jpg": 5091,
	"./promo-muggle-murders-rise_02.jpg": 67,
	"./promo-muggle-murders-rise_03.jpg": 5092,
	"./promo-muggle-murders-rise_04.jpg": 5093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5090;